<div class="subpage-card">
  <div class="subpage-header">
    <div class="header-title">
      @if (icon) {
        <span class="icon" [style.--icon-url]="'url(' + icon + ')'"></span>
      }
      <h2>{{ title }}</h2>
    </div>
    <div class="header-details">
      @if (updatedAt) {
        <span class="meta">
          <app-time-ago [updatedAt]="updatedAt" format="short"></app-time-ago>
        </span>
      }
      @if (showInfoButton) {
        <app-v3-info-button
          [size]="20"
          [opensPage]="true"
          (pageClicked)="infoClicked.emit()"
        ></app-v3-info-button>
      }
    </div>
  </div>
  <div class="subpage-content">
    <ng-content></ng-content>
  </div>
</div>
